import React, { useState } from 'react';
import clanLogo from "../../../assets/images/clan_connect_logo.png"
import './order-confirmed.scss'
import { useEffect } from 'react';
import { useIsUSInfluencer } from '../../../hooks/useIsUSInfluencer';

interface Props {
  userType: string;
  planName: string;
  campaignPlanId: string;
  campaignId: string;
  modalContent?: string;
  children?: any;
  isMobileConfirmed?: boolean;
  status: string;
}

const OrderConfirmedTemplate: React.FC<Props> = ({
  userType,
  planName,
  modalContent,
  children,
  isMobileConfirmed,
  status
}) => {

  const [open_app, set_open_app] = useState(false);
  const [countdown, setCountdown] = useState(5);

  // Foreign influencers are Zap-only, so send them to the Zap hub after a
  // successful subscription instead of the (blocked) campaigns dashboard.
  const isForeignInfluencer = useIsUSInfluencer();
  const influencerHome = isForeignInfluencer ? '/influencer/zap' : '/influencer/dashboard';

  const failedStatuses = ['failed', 'error', 'errored', 'validation_failed', 'blocked', 'halted', 'cancelled', 'expired'];
  const isBrand = ['Brand', 'Agency'].includes(userType);
  // The brand one-time purchases (the web's campaign flow and the brand app's free plan).
  const isOneTimePlan = ['New Campaign', 'New Paid Campaign', 'New Barter Campaign', 'Republish Campaign', 'Upgrade Barter Proposal Limit'].includes(planName);

  function openAppWithFallback() {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    const universalLink = 'https://app.clanconnect.ai/welcome/profile';
    // Back into the app. Brands land on brand/payment-return, which refreshes
    // their plan and steps back to the screen they paid from (OLD: everyone got
    // the influencer profile route, wrong for a brand).
    const androidScheme = isBrand ? 'clanconnect:///brand/payment-return' : 'clanconnect:///welcome/profile';

    // const fallbackUrl = isIOS
    //   ? 'https://apps.apple.com/app/idYOUR_APP_ID'
    //   : 'https://play.google.com/store/apps/details?id=ai.clanconnect.app';

    if (isIOS) {
      // window.location.href = universalLink;
      set_open_app(true);
    } else if (isAndroid) {
      set_open_app(false); 
      let countdown = 5;
      const countdownElement = document.getElementById('countdown');
      if (countdownElement) {
        countdownElement.textContent = countdown.toString();
      }

      const countdownInterval = setInterval(() => {
        countdown--;
        if (countdownElement) {
          countdownElement.textContent = countdown.toString();
        }

        if (countdown === 0) {
          clearInterval(countdownInterval);
          window.location.href = androidScheme;
        }
      }, 1000);
    } else {
      // window.location.href = fallbackUrl;
    }
  }


  // enum to set support mail
  const SupportMail = {
    BRAND_SUPPORT_MAIL: 'brand.support@clanconnect.ai',
    INFLUENCER_SUPPORT_MAIL: 'influencer.support@clanconnect.ai'
  }
  // to redirect to home page after count down ends
  // if (userType === "Influencer") {
  //   if (!isMobileConfirmed) {
  //     // const appUrl = `clanconnect:///welcome/profile`; // Deep link into the app
  //     // const fallbackUrl = isIOS()
  //     //   ? 'https://apps.apple.com/app/idYOUR_APP_ID' // <-- Replace with your actual App Store ID
  //     //   : 'https://play.google.com/store/apps/details?id=ai.clanconnect.app';

  //     // // Try to open the app
  //     // window.location.href = appUrl;

  //     // // Fallback after a short delay
  //     // setTimeout(() => {
  //     //   window.location.href = appUrl;
  //     //   // window.location.href = fallbackUrl;
  //     // }, 2000);

  //     openAppWithFallback();
  //   } else {
  //     let countdown = 5;
  //     const countdownInterval = setInterval(() => {
  //       countdown--;
  //       const countdownElement = document.getElementById('countdown');
  //       if (countdownElement) countdownElement.textContent = countdown.toString();
  //       if (countdown === 0) {
  //         clearInterval(countdownInterval);
  //         window.location.href = "/influencer/dashboard";
  //       }
  //     }, 1000);
  //   }
  // }

  // useEffect(() => {
  //   if (userType === "Influencer" && status === 'captured') {
  //     if (isMobileConfirmed) {
  //       openAppWithFallback();
  //     } else {
  //       let countdown = 5;
  //       const countdownElement = document.getElementById('countdown');
  //       if (countdownElement) {
  //         countdownElement.textContent = countdown.toString();
  //       }

  //       const countdownInterval = setInterval(() => {
  //         countdown--;
  //         const countdownElement = document.getElementById('countdown');
  //         if (countdownElement) {
  //           countdownElement.textContent = countdown.toString();
  //         }

  //         if (countdown === 0) {
  //           clearInterval(countdownInterval);
  //           window.location.href = "/influencer/dashboard";
  //         }
  //       }, 1000);

  //       return () => clearInterval(countdownInterval);
  //     }
  //   }
  // }, [userType, isMobileConfirmed, status]);

  useEffect(() => {
    // A brand who paid from the app goes straight back to it too.
    if (isBrand && isMobileConfirmed && status === "captured") {
      openAppWithFallback();
      return;
    }
    if (userType === "Influencer" && status === "captured") {
      if (isMobileConfirmed) {
        openAppWithFallback();
      } else {
        setCountdown(5); // reset countdown

        const countdownInterval = setInterval(() => {
          setCountdown((prev) => {
            if (prev < 1) {
              clearInterval(countdownInterval);
              window.location.href = influencerHome;
              return 0;
            }
            return prev - 1;
          });
        }, 1000);

        return () => clearInterval(countdownInterval);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType, isMobileConfirmed, status, influencerHome]);

  return (
    <div className="main-content-sec padd-content-top full-width">
      <div className="confirmed-info-container">
        {((userType === "Influencer" || (isBrand && isMobileConfirmed)) && !open_app && status === 'captured') && (
          <div className="redirecting">
            <span>Redirecting in </span>
            {/* <span id="countdown">{5}</span> */}
            <span id="countdown">{countdown}</span>
            <span> seconds...</span>
          </div>
        )}
        <div className="d-flex justify-content-center align-items-center mt-3 mb-4">
          <img
            alt="Clan Connect"
            height="93"
            src={clanLogo}
            style={{ display: 'inline-block', verticalAlign: 'middle' }}
            width="221"
          />
        </div>
        {
          status === 'captured'
          ?
          <strong className="d-block pb-1 text-center" style={{ fontSize: '22px', color: 'green' }}>
            <span className="bi bi-check-lg fs-20"></span>
            <span>{isOneTimePlan ? 'Payment successful' : 'Thank you for subscribing to ClanConnect'}</span>
          </strong>
          :
          failedStatuses.includes(status)
          ?
          <strong className="d-block pb-1 text-center" style={{ fontSize: '22px', color: '#dc3545' }}>
            <span className="bi bi-x-circle fs-20 me-2"></span>
            <span>Payment failed. Please try again or contact support.</span>
          </strong>
          :
          <strong className="d-block pb-1 text-center" style={{ fontSize: '22px', color: '#f59e0b' }}>
            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
            <span>Your payment is being processed. You will receive confirmation shortly.</span>
          </strong>
        }
        {children}
        <p>
          Feel free to email us at{' '}
          {['Brand', 'Agency'].includes(userType) ? (
            <a href={SupportMail.BRAND_SUPPORT_MAIL}>{SupportMail.BRAND_SUPPORT_MAIL}</a>
          ) : (
            <a href={SupportMail.INFLUENCER_SUPPORT_MAIL}>{SupportMail.INFLUENCER_SUPPORT_MAIL}</a>
          )}{' '}
          with any questions or feedback you may have.
        </p>
        <br />
        <p style={{ color: '#0097d0', fontSize: '25px', marginBottom: '10px' }}>Thank You</p>
        <p style={{ fontSize: '18px', margin: '0px', display: 'inline-block' }}>Team ClanConnect</p>
        {
          // From the app, every purchase returns to the app (OLD: the one-time
          // plans showed web-only "View Campaign" / "View Proposals" links).
          // Both open the new flow's Campaigns — the old campaign pages are not linked anywhere.
          isOneTimePlan && !isMobileConfirmed
          ?
            ['Upgrade Barter Proposal Limit'].includes(planName)
            ?
              <a href='/brand/campaigns' className="btn btn-outline-primary d-flex justify-content-center">View Proposals</a>
            :
              <a href='/brand/campaigns' className="btn btn-outline-primary d-flex justify-content-center">View Campaign</a>
          : 
            isMobileConfirmed ? 
            // For mobile confirmed, redirect to mobile app
             !open_app && 
            <span className="btn btn-outline-primary d-flex justify-content-center"
                onClick={() => openAppWithFallback()}
            >OK</span>
              :
            // For web confirmed, redirect to dashboard
            <a href={['Brand', 'Agency'].includes(userType) ? '/brand/dashboard' : influencerHome} className="btn btn-outline-primary d-flex justify-content-center">OK</a>
          }
          {open_app && (
            <p
              style={{
                fontSize: '16px',
                color: '#333',
                backgroundColor: '#f8f9fa',
                padding: '12px 16px',
                borderLeft: '4px solid #007bff',
                borderRadius: '4px',
                margin: '16px 0',
                fontFamily: 'Open Sans, sans-serif',
              }}
            >
              To continue, please open the app.
            </p>
          )}
      </div>
    </div>
  );
};

export default OrderConfirmedTemplate;